<template>
  <div class="boss-main-content-wrap">
    <setting-header
      v-if="isCompanyStaffAccess"
      :breadcrumbs="[{ name: '求人確認' }, isPrePublishedAccess ? { name: '掲載前の求人', pathName: 'jobPrePublished' } : { name: '掲載済みの求人・応募フォームタイプ設定', pathName: 'jobPublished' }]"
      :title="isPrePublishedAccess ? '掲載前の求人プレビュー_検索一覧' : '掲載済みの求人プレビュー_検索一覧' "
      class="hide-for-print"
    />
    <div class="pega-search-result-wrap">
      <div class="grid-x hide-for-print">
        <div class="cell auto">
          <sp-preview-button
            :id="Number(id)"
            :route-name="spRouteNameForJobSearch"
          />
        </div>
        <print-button class="cell shrink" />
      </div>
      <div class="pega-text-small">
        ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。
      </div>
      <job-search-preview-detail
        :job-search-result="jobSearchResult"
        :photo-data="jobSearchResult.mainPhoto"
        :employment-status="jobSearchResult.employmentStatus"
        :pr-codes="jobSearchResult.prCodes"
        :report="jobSearchResult.report"
      />
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import JobSearchPreviewDetail from '@/components/organisms/JobSearchPreviewDetail'
import SpPreviewButton from '@/components/atoms/SpPreviewButton'
import PrintButton from '@/components/atoms/PrintButton'
import jobSearchPreviewCommon from '@/lib/jobSearchPreviewCommon'

export default {
  components: {
    PrintButton,
    SpPreviewButton,
    SettingHeader,
    JobSearchPreviewDetail
  },
  // PC・SP共通処理読み込み
  mixins: [jobSearchPreviewCommon]
}
</script>
